import(/* webpackMode: "eager" */ "/home/interim/frontend/app/efficiency/page.tsx");
